// @flow

/**
 * DOCX Download Service
 * Converts markdown to DOCX and triggers download.
 * Supports embedded chart images via {{CHART_IMAGE:id}} tokens.
 */

import { Packer } from 'docx';
import { saveAs } from 'file-saver';
import { markdownToDocx } from '../utils/markdownToDocx';
import { prepareMarkdownForExport } from '../utils/prepareMarkdownForExport';

/**
 * Convert markdown text to DOCX and trigger download
 * @param {string} markdownText - The markdown content to convert (may contain {{CHART_IMAGE:id}} tokens)
 * @param {string} filename - The filename for the download
 * @param {Object} chartImages - Optional map of displayId → PNG data URL for chart embedding
 */
export const downloadAsDocx = async (
  markdownText: string,
  filename: string,
  chartImages?: { [string]: string },
): Promise<void> => {
  const doc = markdownToDocx(prepareMarkdownForExport(markdownText), chartImages);
  const blob = await Packer.toBlob(doc);
  saveAs(blob, filename);
};
